module.exports = __webpack_public_path__ + "static/media/galleryGT (6).b36ea74c.jpg";